import React from 'react';
import classnames from 'classnames';
import Loader from '../Loader';
import PageHeader from '../PageHeader';
import ProductInfo from '../../ProductInfo';
import './index.scss';

type Props = {
    children: React.ReactNode,
    headerLogo?: string,
    className?: string,
    isProductInfoVisible?: boolean,
};

const BaseLayout = ({children, headerLogo, isProductInfoVisible = true, className}: Props) => {
    return (
        <React.Fragment>
            <Loader/>

            <div className={classnames('base-layout', className)}>
                <PageHeader className='base-layout-page-header' logo={headerLogo}/>

                <div className='base-layout-content'>
                    {children}
                </div>

                {isProductInfoVisible && <ProductInfo/>}
            </div>
        </React.Fragment>
    );
};

export {BaseLayout as TestableBaseLayout};
export default BaseLayout;
